import React, { useEffect, useState } from "react";
import LeadsByOriginChart from "./leadsByOrigin";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";

const StartEndDateLeadsByOrigin = () => {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filterType, setFilterType] = useState("range"); // monthly | range

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  // const formatDate = (date) => date.toISOString().split("T")[0];

  // const today = new Date();
  // const day = today.getDay();

  // let previousSaturday = new Date(today);
  // if (day === 6) {
  //   previousSaturday.setDate(today.getDate() - 7);
  // } else {
  //   previousSaturday.setDate(today.getDate() - (day + 1));
  // }

  // const [startDate, setStartDate] = useState(formatDate(previousSaturday));
  // const [endDate, setEndDate] = useState(formatDate(today));

  const formatDate = (date, useUTC = false) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  
    let year, month, day;
  
    if (useUTC) {
      year = date.getUTCFullYear();
      month = String(date.getUTCMonth() + 1).padStart(2, "0");
      day = String(date.getUTCDate()).padStart(2, "0");
    } else {
      year = date.getFullYear();
      month = String(date.getMonth() + 1).padStart(2, "0");
      day = String(date.getDate()).padStart(2, "0");
    }
  
    return `${year}-${month}-${day}`;
  };

  const getDefaultWeekRange = () => {
    // Get today in IST
    const today = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );
    today.setHours(0, 0, 0, 0);
  
    const day = today.getDay(); // Sun=0 ... Sat=6
  
    // Start of week (Sunday)
    const start = new Date(today);
    start.setDate(today.getDate() - day);
    start.setHours(0, 0, 0, 0);
  
    // End of week (Saturday)
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
  
    return { start, end };
  };
  
  const [startDate, setStartDate] = useState(() => {
    const { start } = getDefaultWeekRange();
    return formatDate(start);
  });
  
  const [endDate, setEndDate] = useState(() => {
    const { end } = getDefaultWeekRange();
    return formatDate(end);
  });
  
  useEffect(() => {
    setLoading(true);

    let url = "";

    if (filterType === "monthly") {
      url = `/incentive/getLeadsGenratedStartEndDate?month=${selectedMonth}&year=${selectedYear}`;
    } else {
      if (!startDate || !endDate) {
        setLoading(false);
        return;
      }
      url = `/incentive/getLeadsGenratedStartEndDate?startDate=${startDate}&endDate=${endDate}`;
    }

    performRequest("GET", url)
      .then((res) => {
        if (res.status === 200) {
          setGraphData(res?.data?.graphData || []);
        } else {
          Toast("error", "Error while getting leads data!");
        }
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  }, [filterType, selectedMonth, selectedYear, startDate, endDate]);

  if (loading) return <LoadingPage />;

  const getMonthName = (monthIndex) =>
    new Date(0, monthIndex).toLocaleString("default", { month: "long" });

  return (
    <div className="container py-4">
      {/* Filter Type */}
      <div className="flex gap-2 p-2">
        <select
          className="border p-2 rounded"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="monthly">Month Wise</option>
          <option value="range">Date Range</option>
        </select>
      </div>

      {/* Month + Year */}
      {filterType === "monthly" && (
        <div className="flex gap-2 p-2">
          <select
            className="border p-2 rounded"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {Array.from({ length: 5 }, (_, i) => 2022 + i).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

          <select
            className="border p-2 rounded"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {Array.from({ length: 12 }, (_, index) => (
              <option key={index} value={index + 1}>
                {getMonthName(index)}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Start Date - End Date */}
      {filterType === "range" && (
    
        <div className="flex gap-2 p-2">
          <input
            type="date"
            className="border p-2 rounded"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      )}

      {/* Chart */}
      <LeadsByOriginChart data={graphData} />
    </div>
  );
};

export default StartEndDateLeadsByOrigin;
